export default __webpack_public_path__ + "static/media/trackinfo_overview.8690c146.webp";